import { render, staticRenderFns } from "./PdpDeliveryTab.vue?vue&type=template&id=7da9447d&"
import script from "./PdpDeliveryTab.vue?vue&type=script&lang=js&"
export * from "./PdpDeliveryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports